import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const ResetPassword = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const userId = searchParams.get("id");
    const token = searchParams.get("token");

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const resetHandle = event => {
        event.preventDefault();

        if (password !== confirmPassword) {
            toast.error("Passwords do not match", {
                autoClose: 5000, position: "top-right"
            });

            return;
        }

        fetch('/api/v1/resetPassword', {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                password: password,
                token: token,
                userId: userId
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    toast.success("Password reset successful", {
                        autoClose: 2000, position: "top-right"
                    });
                    setTimeout(() => navigate("/login"), 2000);
                } else {
                    toast.error(data.message, {
                        autoClose: 5000, position: "top-right"
                    });
                }
            })
            .catch(err => {
                console.error(err);
            });
    };

    return (
        <>
            <div className="logo">
                <img src="/images/logo-circle-dark.png" alt="logo" className="circle" />
                <img src="/images/brevia-brown.png" className="brevia"></img>
            </div>
            <div className="logo-wrapper">
                <h2>Log In</h2>
                <form onSubmit={resetHandle} className="password_form">
                    <label htmlFor="set-pw">
                        Set your password
                    </label>
                    <div className="input_wrapper">
                        <input
                            id="set-pw"
                            type={showPassword ? "text" : "password"}
                            placeholder="Enter your password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete="new-password"
                            required
                        />
                        <span
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            {showPassword ? <FaEye /> : <FaEyeSlash />}
                        </span>
                    </div>

                    <label htmlFor="confirm-pw">
                        Confirm your password
                    </label>
                    <div className="input_wrapper">
                        <input
                            id="confirm-pw"
                            type={showConfirmPassword ? "text" : "password"}
                            placeholder="Confirm your password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                        <span
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        >
                            {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
                        </span>
                        {/* <Link to="/forgotPassword">Forgot your password?</Link> */}
                    </div>

                    <button type="submit">Submit</button>
                </form>
            </div>
        </>
    )

}

export default ResetPassword;